import React from 'react';
const SparkleIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15 8.5 22 9 17 14 19 21 12 17.5 5 21 7 14 2 9 9 8.5" />
  </svg>
);
export default SparkleIcon;